import { RoleEnum, APP_ROUTES } from '@core/constants';

export const resolveHomeByRoles = (roles: string[]): string => {
  const normalizedRoles = roles.map((role) => role.trim().toUpperCase());

  if (
    normalizedRoles.includes(RoleEnum.ADMIN) ||
    normalizedRoles.includes(RoleEnum.SUPER_ADMIN)
  ) {
    return APP_ROUTES.HOME_ADMIN;
  }

  if (normalizedRoles.includes(RoleEnum.TECHNICIAN)) {
    return APP_ROUTES.HOME_TECHNICAL;
  }

  if (normalizedRoles.includes(RoleEnum.RECEPTIONIST)) {
    return APP_ROUTES.HOME_RECEPTION;
  }

  return APP_ROUTES.LOGIN;
};
